"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AndroidDeviceConnector = void 0;
// @constants
const platform_1 = require("../../../platform");
const deviceConnector_1 = require("../deviceConnector");
class AndroidDeviceConnector extends deviceConnector_1.DeviceConnector {
    constructor() {
        super(...arguments);
        this.webViewPlatform = platform_1.Platform.ANDROID;
        this.areToolsLoaded = () => {
            var _a;
            return typeof ((_a = window.nativeBridge) === null || _a === void 0 ? void 0 : _a.request) === 'function';
        };
        this.call = (type, payload) => {
            var _a, _b;
            (_b = (_a = window.nativeBridge) === null || _a === void 0 ? void 0 : _a.request) === null || _b === void 0 ? void 0 : _b.call(_a, type, JSON.stringify(payload));
        };
    }
}
exports.AndroidDeviceConnector = AndroidDeviceConnector;
//# sourceMappingURL=deviceConnectorAndroid.js.map